export default "__VITE_ASSET__CCeSTCA0__"